var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "보호구 지급 상세" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.data.statusCd === "SSC0000010"
                            ? _c("c-qr-btn", {
                                attrs: {
                                  mobileUrl:
                                    "/sop/sas/safetyGear?requestGiveInfoId=" +
                                    _vm.param.requestGiveInfoId,
                                },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled && _vm.signFlag
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.completeUrl,
                                  isSubmit: _vm.isComplete,
                                  param: _vm.data,
                                  mappingType: "PUT",
                                  label: "지급완료",
                                  icon: "check",
                                },
                                on: {
                                  beforeAction: _vm.completeData,
                                  btnCallback: _vm.completeCallback,
                                },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled && _vm.isOld
                            ? _c("c-btn", {
                                attrs: {
                                  label: "삭제",
                                  icon: "delete_forever",
                                },
                                on: { btnClicked: _vm.removeData },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.saveType,
                                  label: "저장",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            label: "지급일",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            default: "today",
                            name: "giveDate",
                          },
                          model: {
                            value: _vm.data.giveDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "giveDate", $$v)
                            },
                            expression: "data.giveDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _vm.param.isRequest === "N"
                          ? _c("c-plant", {
                              attrs: {
                                type: "edit",
                                required: true,
                                label: "사업장",
                                disabled: _vm.disabled,
                                editable: _vm.editable,
                                name: "plantCd",
                              },
                              model: {
                                value: _vm.data.plantCd,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, "plantCd", $$v)
                                },
                                expression: "data.plantCd",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-dept", {
                          attrs: {
                            required: true,
                            label: "지급부서",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            plantCd: _vm.data.plantCd,
                            name: "giveDeptCd",
                          },
                          model: {
                            value: _vm.data.giveDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "giveDeptCd", $$v)
                            },
                            expression: "data.giveDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            label: "불출담당자",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            plantCd: _vm.data.plantCd,
                            name: "giveUserId",
                          },
                          model: {
                            value: _vm.data.giveUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "giveUserId", $$v)
                            },
                            expression: "data.giveUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            label: "수령인",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            plantCd: _vm.data.plantCd,
                            name: "recipientId",
                          },
                          model: {
                            value: _vm.data.recipientId,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "recipientId", $$v)
                            },
                            expression: "data.recipientId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "보호구 지급 목록",
                tableId: "table",
                columns: _vm.gridColumns,
                data: _vm.data.detailList2,
                merge: _vm.grid.merge,
                isFullScreen: false,
                columnSetting: false,
                filtering: false,
                usePaging: false,
                isExcelDown: false,
                editable: _vm.editable && !_vm.disabled,
                gridHeight: "600px",
                selection: "multiple",
                rowKey: "giveListId",
              },
              scopedSlots: _vm._u([
                {
                  key: "customArea",
                  fn: function ({ props, col }) {
                    return [
                      col.name === "userArray"
                        ? [
                            _c("c-multi-field", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                userInfo: _vm.userInfo,
                                isArray: "",
                                type: "user",
                                label: "",
                                name: `userArray${props.rowIndex}`,
                              },
                              on: {
                                "update:userInfo": function ($event) {
                                  _vm.userInfo = $event
                                },
                                "update:user-info": function ($event) {
                                  _vm.userInfo = $event
                                },
                                dataChange: function ($event) {
                                  return _vm.dataChange(props, col)
                                },
                              },
                              model: {
                                value: props.row[col.name],
                                callback: function ($$v) {
                                  _vm.$set(props.row, col.name, $$v)
                                },
                                expression: "props.row[col.name]",
                              },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            },
            [
              _c("template", { slot: "table-button" }, [
                _c(
                  "div",
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable &&
                        !_vm.disabled &&
                        _vm.param.isRequest === "Y"
                          ? _c("c-btn", {
                              attrs: {
                                label: "신청 보호구 선택",
                                icon: "save_alt",
                              },
                              on: { btnClicked: _vm.addRequestGear },
                            })
                          : _vm._e(),
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: { label: "추가", icon: "add" },
                              on: { btnClicked: _vm.addGear },
                            })
                          : _vm._e(),
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: { label: "제외", icon: "remove" },
                              on: { btnClicked: _vm.removeGear },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }